<template>
  <WidgetCard title="Företag att godkänna" subtitle="Att hantera">
    <v-data-table hide-default-footer
      :headers="[
        {text: 'Företagsnamn', value: 'name'},
        {text: 'Org.nr.', value: 'organizationalNumber'},
        {text: 'Avtalstyp', value: 'contracttype.name'},
        {text: 'Adress', value: 'postalAddress1'},
        {text: 'Postnr', value: 'postalZip'},
        {text: 'Ort', value: 'postalCity'},
      ]"
      :class="'clickable'"
      :items="items"
      :items-per-page="-1"
      :server-items-length="totalRows"
      item-key="id"
      @click:row="showCompany"
    >
    </v-data-table>
  </WidgetCard>
</template>


<script>
import API from '@/services/api'
import WidgetCard from '@/components/widgets/WidgetCard.vue'
export default {
  name: 'CompaniesAwaitingApproval',

  components: { WidgetCard },

  data() {
    return {
      items: [],
      totalRows: 0
    };
  },
  created() {
    this.fetchCompanies();
  },
  methods: {
    fetchCompanies() {
      const params = {
        listCompaniesAwaitingApproval: true
      }
      API.widgetListCompanies(params)
        .then(res => {
        this.items = res.data.rows;
        this.totalRows = res.data.count;
      }).catch(error => {
        console.log('There was an error:', error);
      });
    },
    showCompany(item) {
      this.$router.push({ name: 'Company', params: { id: item.id } }).catch(() => { });
    },
  }
}
</script>